<template>
  <div>
    <v-card outlined tile>
      <v-card-text>
        <strong>{{ name }}</strong>
      </v-card-text>
      <hr class="m-0">
      <v-card-title><h4>{{ data.count }}</h4></v-card-title>
    </v-card>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    name: {
      type: String,
      default: 'Title'
    },
    data: {
      type: Object,
      required: true
    },
    count: {
      type: Boolean,
      required: true
    },
    setColors: {
      type: Array,
      required: false
    },
    height: {
      type: Number,
      default: 350
    }
  },
  data() {
    return {
      chartOptions: {
        chart: {
          height: 350,
          type: 'bar'
        },
        plotOptions: {
          bar: {
            horizontal: true,
          }
        },
        colors: this.setColors,
        dataLabels: {
          formatter: function (val, opt) {
            const goals =
              opt.w.config.series[opt.seriesIndex].data[opt.dataPointIndex]
                .goals

            if (goals && goals.length) {
              return `${val} / ${goals[0].value}`
            }
            return val
          }
        },
        legend: {
          show: false,
        }
      },
    }
  },
  computed: {
  },
  methods: {

    colored(value) {
      return value < 0 ? 'red' : 'green'
    }
  }
}
</script>